import { render, staticRenderFns } from "./CrossOrgMain.vue?vue&type=template&id=36a2bf7f"
import script from "./CrossOrgMain.vue?vue&type=script&lang=js"
export * from "./CrossOrgMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/ffa2b6072150c7f8/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36a2bf7f')) {
      api.createRecord('36a2bf7f', component.options)
    } else {
      api.reload('36a2bf7f', component.options)
    }
    module.hot.accept("./CrossOrgMain.vue?vue&type=template&id=36a2bf7f", function () {
      api.rerender('36a2bf7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/CrossOrg/CrossOrgMain.vue"
export default component.exports